module.exports = __webpack_public_path__ + "img/1591499290.80ab0715.jpg";